// ============================================================================
// PsyReportsList — СПИСОК ОТЧЁТОВ ПО МЕТОДИКАМ (карточки, без таблиц).
//
// Отдельный компонент (SRP): панель отчётов только загружает данные и
// переключает экраны. Карточка показывает методику, имя отчёта, признаки
// «отчёт» и «печать»; клик открывает выбранный отчёт.
// ============================================================================

import { ChevronRight, FileText } from 'lucide-react';
import type { PsyReportEntry } from '@/lib/psyReports';

export interface PsyReportsListProps {
  entries: PsyReportEntry[];
  filtersActive: boolean;
  onOpen: (key: string) => void;
}

export function PsyReportsList({ entries, filtersActive, onOpen }: PsyReportsListProps) {
  return (
    <>
      {filtersActive && (
        <div className="text-[11px] text-muted-foreground">
          Период и пациент применятся к строкам отчёта и протоколам после открытия отчёта.
        </div>
      )}
      {entries.length === 0 ? (
        <div className="rounded-lg border px-3 py-3 text-xs bg-card">
          <div className="text-sm font-medium">Отчёты по методикам не найдены</div>
          <div className="text-muted-foreground mt-1">
            В базе нет отчётов, сопоставленных методикам (имя отчёта = синониму методики).
            Проверьте поставку модуля «ГидраМедик: психология» в «Поставках».
          </div>
        </div>
      ) : (
        <div className="space-y-2">
          {entries.map((entry) => (
            <button
              key={entry.key}
              type="button"
              className="w-full text-left rounded-lg border bg-card px-3 py-2.5 hover:bg-accent/40 transition-colors"
              onClick={() => onOpen(entry.key)}
            >
              <div className="flex items-start gap-2">
                <FileText className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium truncate">{entry.methodName}</div>
                  <div className="text-[11px] text-muted-foreground truncate">
                    {entry.reportName || 'отчёт для методики не найден'}
                  </div>
                  {entry.reportDescription && (
                    <div className="text-[11px] text-muted-foreground mt-0.5 line-clamp-2">
                      {entry.reportDescription}
                    </div>
                  )}
                  <div className="mt-1 flex flex-wrap gap-1">
                    {entry.reportId && (
                      <span className="rounded-full border border-primary/25 bg-primary/10 px-1.5 py-0.5 text-[10px] text-primary">
                        отчёт
                      </span>
                    )}
                    {entry.printFormId && (
                      <span className="rounded-full border px-1.5 py-0.5 text-[10px] text-muted-foreground">
                        печать: {entry.printFormName || 'Заключение по тесту'}
                      </span>
                    )}
                    {!entry.methodCode && (
                      <span className="rounded-full border px-1.5 py-0.5 text-[10px] text-muted-foreground">
                        без методики
                      </span>
                    )}
                  </div>
                </div>
                <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0 mt-1" />
              </div>
            </button>
          ))}
        </div>
      )}
    </>
  );
}
